import { AsyncPipe } from "@angular/common";
import { Component, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { TabComponent } from "@components/tabs/tab/tab.component";
import { TabsComponent } from "@components/tabs/tabs.component";
import { TogglePanelComponent } from "@components/toggle-panel/toggle-panel.component";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AtgardVirkeskostnadComponent } from "../../atgarder/atgard-forkalkyl/atgard-virkeskostnad/atgard-virkeskostnad.component";
import { ForkalkylNettoberakningComponent } from "../../atgarder/atgard-forkalkyl/forkalkyl-nettoberakning/forkalkyl-nettoberakning.component";
import { KontraktMediatorService } from "../../services/kontrakt-mediator.service";

@Component({
    selector: "rask-kontrakt-forkalkyl",
    templateUrl: "./kontrakt-forkalkyl.component.html",
    styleUrls: ["./kontrakt-forkalkyl.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TogglePanelComponent,
        TabsComponent,
        TabComponent,
        AtgardVirkeskostnadComponent,
        ForkalkylNettoberakningComponent,
        AsyncPipe
    ]
})
export class KontraktForkalkylComponent implements OnInit {
    protected isLeveransvirke$: Observable<boolean>;

    private readonly kontraktMediatorService = inject(KontraktMediatorService);

    ngOnInit(): void {
        this.isLeveransvirke$ = this.kontraktMediatorService.kontrakt$.pipe(
            map(kontrakt => kontrakt.isLeveransvirke)
        );
    }
}
